import { defineMessages } from "react-intl";

export const AIR_MESSAGES = defineMessages({
  periodMonths: {
    id: "funding-application: air revenue source period months",
    defaultMessage: "{period, plural, =1 {# month} other {# months}}",
  },
  periodWeeks: {
    id: "funding-application: air revenue source period weeks",
    defaultMessage: "{period, plural, =1 {# week} other {# weeks}}",
  },
  // bank statements
  bankStatementDefaultBankName: {
    id: "funding-application: air bank statement page default bank name",
    defaultMessage: "bank",
  },
  bankStatementBankStatementsText: {
    id: "funding-application: air bank statement upload bank statements label",
    defaultMessage: "Upload bank statements",
  },
  bankStatementCompleteRequestButtonText: {
    id: "funding-application: air bank statement complete request button text",
    defaultMessage: "Complete request",
  },
  bankStatementPDFText: {
    id: "funding-application: air bank statement pdf text",
    defaultMessage: "Please provide bank statements in PDF format.",
  },
  bankStatementPDForCSVText: {
    id: "funding-application: air bank statement pdf or csv text",
    defaultMessage:
      "Please provide bank statements in PDF format for full calendar months. For the period {startOfMonth} to {currentDate}, please provide bank transactions in either PDF or CSV format.",
  },

  bankStatementUnableToProvideTextareaText: {
    id: "funding-application: air bank statement unable to provide textarea label",
    defaultMessage: "Please explain why you are unable to provide statements for account {bankAccountNum}",
  },
});
